export const reloginUser = function () {
    var url = (window.location != window.parent.location) ? document.referrer : document.location.href
    window.parent.location.href = url
}

export const toast = function (message, options = {}) {

    const standardOptions = {
        toaster: 'b-toaster-top-left',
        autoHideDelay: 5000,
        solid: true,
        appendToast: false,
    }

    const mergedOptions = Object.assign({}, standardOptions, options)
    //this.$root.$bvToast.toast(message, mergedOptions);
    this.$bvToast.toast(message, mergedOptions)
}

export const successToast = function (message, options = {}) {
    const standardOptions = {
        variant: 'success'
    }
    const mergedOptions = Object.assign({}, standardOptions, options)
    this.toast(message, mergedOptions)
}

export const errorToast = function (message, options = {}) {
    const standardOptions = {
        variant: 'danger'
    }
    const mergedOptions = Object.assign({}, standardOptions, options)
    this.toast(message, mergedOptions)
}

export const errorAlert = function (msg = null) {
    if (msg != null & msg != '') {
        this.$store.dispatch('alert/setAlert', { type: 'danger', message: msg })
        return ''
    }

    let message = this.__('lang.my_account.alert.not_saved')
    if (this.form_type == 'create') this.$store.dispatch('alert/setAlert', { type: 'danger', message: message })
    else if (this.form_type == 'edit') this.$store.dispatch('alert/setAlert', { type: 'danger', message: message })
    else if (this.form_type == 'duplicate') this.$store.dispatch('alert/setAlert', { type: 'danger', message: message })
    else this.$store.dispatch('alert/setAlert', { type: 'danger', message: message })
    return ''
}

export const successAlert = function (msg = null) {
    if (msg != null & msg != '') {
        this.$store.dispatch('alert/setAlert', { type: 'success', message: msg })
        return ''
    }

    // eventuell Übersetzung neu anlegen
    if (this.form_type == 'create') this.$store.dispatch('alert/setAlert', { type: 'success', message: this.__('lang.my_account.alert.created') })
    else if (this.form_type == 'edit') this.$store.dispatch('alert/setAlert', { type: 'success', message: this.__('lang.my_account.alert.saved') })
    else if (this.form_type == 'duplicate') this.$store.dispatch('alert/setAlert', { type: 'success', message: this.__('lang.my_account.alert.duplicated') })
    else this.$store.dispatch('alert/setAlert', { type: 'success', message: this.__('lang.my_account.alert.saved') })
    return ''
}

export const FormSubmitButton = function () {
    if (this.form_type == 'create') return this.__('lang.my_account.apply')
    if (this.form_type == 'edit') return this.__('lang.my_account.save')
    if (this.form_type == 'duplicate') return this.__('lang.my_account.apply')
    return ''
}

export const errorReport = function (error) {
    if (error.response) {
        // Request made and server responded
        console.log(error.response.data) // Create articles failed
        console.log(error.response.status) // 400
        console.log(error.response.headers)
    } else if (error.request) {
        // The request was made but no response was received
        console.log(error.request)
    } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message)
    }
}

/* somehow this function existed in two variations. one for name and one for label */
export const setInputLabels = function (value) {
    var array = []
    for (var i = 0; i < value.length; i++) {
        if (value[i].name) {
            array.push({ value: value[i].id, text: this.__(value[i].name) })
        } else if (value[i].label) {
            array.push({ value: value[i].id, text: this.__(value[i].label) })
        }
    }
    return array
}

export const setInputLabelsWithLocale = function (value) {
    var array = []
    for (var i = 0; i < value.length; i++) {
        var name = ''
        name = 'lang.' + value[i].name
        array.push({ value: value[i].id, text: this.__(name) })
    }
    return array
}

export const validateState = function (ref, scope = null) {
    let check
    if (scope == null) {
        check = this.veeFields
    } else {
        scope = '$' + scope
        if (!this.veeFields[scope]) return null
        check = this.veeFields[scope]
    }

    if (check[ref] && (check[ref].dirty || check[ref].validated)) {
        return !this.veeErrors.has(ref)
    }
    return null
}

export const validateScope = async function (scope, failed = null) {
    let status
    status = await this.$validator.validateAll(scope)

    if (failed !== null && !status) {
        failed.scopes.push(scope)
    }

    return status
}

export const validateAll = async function (scopes, failed = null) {
    let validations = []

    if (failed !== null) {
        failed.scopes = []
    }

    scopes.forEach((scope) => {
        validations.push(this.validateScope(scope, failed))
    })
    return Promise.all(validations).then((results) => results.every((r) => r))
}
